<template>
  <div
    class="workbench-sequence-waggon-workpackage"
    >
    <slot name="content"/>
  </div>
</template>
<script>
  export default {
    props: [],
    data: () => ({
    }),
  }
</script>
<style>
  .workbench-sequence-waggon-workpackage {
    display: flex;
    height: calc(100% - 33px);
  }
</style>
